<template>
  <BaseModal
    :aberto="aberto"
    titulo-acessivel="Quero ser cliente Creditall"
    @fechar="fechar"
  >
    <div class="qsc">
      <h3 class="qsc__titulo">Antes de sair, uma pergunta:</h3>
      <p class="qsc__destaque">Sua empresa perde vendas por não oferecer mais opções de pagamento?</p>
      <p class="qsc__subtitulo">
        Mais de 10 mil empresas utilizam a Creditall para ampliar suas formas de
        recebimento e vender com mais segurança. Deixe seu contato — nosso time
        responde ainda hoje.
      </p>

      <LeadForm variant="modal" origem="exit_intent" />

      <button type="button" class="qsc__dispensar" @click="fechar">
        Agora não
      </button>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue';
import LeadForm from './LeadForm.vue';

export default {
  name: 'ModalQueroSerCliente',
  components: { BaseModal, LeadForm },
  props: {
    aberto: { type: Boolean, required: true },
  },
  emits: ['fechar'],
  methods: {
    fechar() {
      this.$emit('fechar');
    },
  },
};
</script>

<style scoped>
.qsc__titulo {
  font-size: 16px;
  font-weight: 600;
  color: #888;
  text-align: center;
  margin: 0 0 2px;
}
.qsc__destaque {
  font-size: 24px;
  font-weight: 800;
  color: #bf1b39;
  text-align: center;
  margin: 0 0 12px;
}
.qsc__subtitulo {
  font-size: 14px;
  color: #555;
  text-align: center;
  margin: 0 0 24px;
  line-height: 1.5;
}

.qsc__dispensar {
  display: block;
  margin: 16px auto 0;
  background: transparent;
  border: 0;
  color: #999;
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
}
.qsc__dispensar:hover {
  color: #666;
}
</style>
